import { AES, SHA512 } from "crypto-js";
import * as CryptoJS from "crypto-js";

export const generateSHA512HashAndEncryptInES6 = (data) => {
  const hash = SHA512(data);
  const hashResult = hash.toString();
  const encryptedText = AES.encrypt(
    hashResult,
    process.env.REACT_APP_KEY
  ).toString();
  return encryptedText;
};


export function generateES6Hash(data) {
  const encryptedText = CryptoJS.AES.encrypt(
    data,
    process.env.REACT_APP_KEY
  ).toString();
  return encryptedText;
}

export function decryptES6Hash(encryptedText) {
  const decryptedData = CryptoJS.AES.decrypt(
    encryptedText,
    process.env.REACT_APP_KEY
  ).toString(CryptoJS.enc.Utf8);
  return decryptedData;
}

